import './styles.css';
import Card from '../Card';
import React from 'react';
import RsvpService from '../../services/RsvpService';
import PastSessionList from './components/PastSessionList';
import Session from './components/Session';
import Utils from '../../services/utils/utils';
import DateUtils from '../../services/DateUtils';
import BookSessionsBtn from '../BookSessionsBtn';
import {__, STR_KEY} from '../../services/Translate';

const Sessions = ({sessions = [], event}) => {
    const hasSessions    = Boolean(sessions && sessions.length > 0);
    const activeSessions = getSessionsByChronology(sessions, 'active');
    const pastSessions   = getSessionsByChronology(sessions, 'past').sort((a, b) =>{
        if(a.end_datetime > b.end_datetime) { return -1; }
        if(a.end_datetime < b.end_datetime) { return 1; }
        return 0;
    });
    const bookMoreSessionsBtn = RsvpService.isSingleEvent(event) || RsvpService.hasEventPassed(event) ? null : <BookSessionsBtn event={event} />

    return (            
        <div className="sessions allSessionTickets">
            {hasSessions ? (
                <>
                    <SessionList event={event} sessions={activeSessions} />
                    <PastSessionList event={event} sessions={pastSessions} />
                    { bookMoreSessionsBtn }
                </>
            ) : (
                <>
                    <NoSessionsBooked event={event} />
                    { bookMoreSessionsBtn }
                 </>
            ) }
        </div>
    );
}

export const SessionList = ({sessions, event}) => {
    const sortedSessions = sessions.sort((a,b) => {
        return ((a.time || {}).start_datetime > (b.time || {}).start_datetime) ? 1 : (((b.time || {}).start_datetime > (a.time || {}).start_datetime) ? -1 : 0);
    });

    return groupSessionsByDay(sortedSessions).map((day, index) => {
        return (
            <Separator key={index} label={Utils.formatDate(day.date, 'dddd, Do MMMM YYYY')}>
                <SessionsCollection sessions={day.sessions} event={event} />
            </Separator>
        );
    });
};

/**
 * @return {Array<JSX.Element>} an array of Session components
 */
export const SessionsCollection = ({sessions, event}) => {
    return sessions.map((session, i) => {
        return (
            <Session 
                event={event}
                hasBooked={true}
                sessionTime={session.time}
                data={session}
                key={i}
            />
        );
    });
};

/**
 * Wrap children with a text label
 */
export const Separator = ({label, children}) => {
    return (
        <div className="separatorGroup">
            <h2 className="separatorLabel">{label}</h2>
            {children}
        </div>
    )
};

export const NoSessionsBooked = ({event}) => {
    if (event && event.registration_type === 10) return null
    else if (RsvpService.hasEventPassed(event) || RsvpService.hasEventClosed(event)) return null;

    return (
        <Card className="noSessionsBooked">
            <div>
                {__(STR_KEY.SESSIONS_LIST_FALLBACK)}
            </div>
        </Card>
    );
}

/**
 * Group sessions by day
 * 
 * @param {Array<any>} data 
 * 
 * @return {Array<object>} object for each day
 */
export const groupSessionsByDay = (sessions = []) => {
    const groups = sessions.reduce((groups, session) => {
        const date = session.time.start_datetime.split(' ')[0];

        if (!groups[date]) {
            groups[date] = [];
        }

        groups[date].push(session);

        return groups;
    }, {});

    return Object.keys(groups).map((date) => {
        return {
            date,
            sessions: groups[date]
        };
    });
}

/**
 * Group sessions by chronology
 * 
 * @param {Array<any>} data 
 * 
 * @return {Array<object>} object for each session
 */
export const getSessionsByChronology = (sessions = [], chronology = 'active') => {
    const now = DateUtils.utcNow();
    return sessions.filter(session => {
        if (session.time) {
            return chronology === 'past' ? now > session.time.end_datetime_utc : now < session.time.end_datetime_utc;
        } 
        return false;
    });
}

export default Sessions;
